/**
 * Created by alex.shmaltsuev on 2016-06-14.
 */
import initialState from '../store/initialstate';
import C from '../constants/intl';

export default (state = initialState().intl, action = null) => {
    switch(action.type){
        case C.GET_SSP_INTL:
            return state.set(C.INTL_OBJECT,action.payload);
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./reducers/intl.js